module.exports = __webpack_public_path__ + "static/media/play.a5fa2ee3.svg";